export function TopBar() {
  return (
    <div className="topbar">
      <div className="topbar-logo">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 3 A 9 9 0 1 0 19 17 L 19 12 L 12 12"
            stroke="#1d3050"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="butt"
          />
        </svg>
        <span className="topbar-logo-text">
          ClaimCenter<sup>TM</sup>
        </span>
      </div>
      <div className="topbar-nav">
        <div className="topbar-nav-item has-dropdown">
          <span>
            <u>D</u>esktop
          </span>
        </div>
        <div className="topbar-nav-item has-dropdown">
          <span>
            <u>C</u>laim (000-00-000389)
          </span>
        </div>
        <div className="topbar-nav-item has-dropdown">
          <span>
            <u>S</u>earch
          </span>
        </div>
        <div className="topbar-nav-item has-dropdown">
          <span>
            <u>A</u>ddress B<u>o</u>ok
          </span>
        </div>
        <div className="topbar-nav-item">Dashboard</div>
        <div className="topbar-nav-item">
          <u>T</u>eam
        </div>
        <div className="topbar-nav-item has-dropdown">Administration</div>
        <div className="topbar-nav-item no-divider">Vacation</div>
      </div>
      <div className="topbar-spacer" />
      <div className="topbar-right">
        <span className="icon-btn" title="Bookmarks">
          <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
            <path d="M2 2v13l6-3 6 3V2H2zm1 1h10v10.5l-5-2.5-5 2.5V3z" />
          </svg>
        </span>
        <span className="icon-btn" title="Settings">
          <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
            <path d="M9.4 1H6.6L6 3.3l-1.3.6L2.7 3l-2 2L1.8 6.9 1.2 8.2 0 9V11h2.3l.6 1.3-1 2 2 2 1.9-1 1.3.6L6 16h2.4l.6-1.3 1.3-.6 2 1 2-2-1-1.9.6-1.3 1.4-.8V9l-2.3-.7-.6-1.3 1-2-2-2-1.9 1L9.4 3 9.4 1zM8 5.5A2.5 2.5 0 1 1 8 10.5 2.5 2.5 0 0 1 8 5.5z" />
          </svg>
        </span>
        <input className="topbar-search" placeholder="Go to (Alt+/)" />
      </div>
    </div>
  );
}
